import { createSelector } from '@reduxjs/toolkit';
import selectWishlistPageActions from '@spa/lib/store/wishlists/selectors/selectWishlistPageActions';

const selectSucceededCreateMyWishlistActionIds = createSelector(
  [selectWishlistPageActions],
  (wishlistsPageActions): ReadonlyArray<number> =>
    wishlistsPageActions.createMyWishlist.succeeded.map(
      (action): number => action.requestedActionId
    )
);

export default selectSucceededCreateMyWishlistActionIds;
